import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ErrorDialog = ({ open, onClose, errors }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "4px",
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
        },
      }}
    >
      <DialogTitle
        sx={{
          pb: 1,
          fontWeight: 400,
          fontSize: "1.25rem",
          color: "rgba(0, 0, 0, 0.87)",
        }}
      >
        Import Error
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: "#212121",
          })}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        {errors && (
          <>
            <Box
              sx={{
                bgcolor: "#FEE2E2",
                p: 2,
                borderRadius: 1,
                mb: 2,
              }}
            >
              <Typography
                sx={{
                  color: "rgba(0, 0, 0, 0.87)",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Error details
              </Typography>
              {errors.map((item, index, arr) => (
                <Typography
                  sx={{
                    color: "rgba(0, 0, 0, 0.57)",
                    fontSize: "0.875rem",
                    fontWeight: 400,
                    mb: index < arr.length - 1 ? 2 : 0,
                    wordBreak: "break-all",
                  }}
                >
                  {item}
                </Typography>
              ))}
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ErrorDialog;
